import PropertySov from "./SOV/PropertySov";
import SOV from "./SOV/SOV";
import BrokerTowerTab from "./brokerTower/BrokerTowerTab";
import CatExposures from "./catExposures/CatExposures";
import LayerEditor from "./layerEditor/LayerEditor";
import LossDevelopment from "./lossDevelopment/LossDevelopment";
import * as navigationSupport from "components/common/Navigation.support";
import PricingAssumptions from "components/inputs/Pricing/PricingAssumptions";
import Attachments from "components/inputs/attachments/Attachments";
import AutoExposureRating from "components/inputs/autoExposureRating/AutoExposureRating";
import Claims from "components/inputs/claims/Claims";
import Coverages from "components/inputs/coverage/Coverages";
import Currencies from "components/inputs/currency/Currencies";
import Exposure from "components/inputs/exposure/Exposure";
import Flags from "components/inputs/flags/Flags";
import GlExposures from "components/inputs/glExposures/GlExposures";
import LossRatingInput from "components/inputs/lossRating/LossRating";
import PremDeduct from "components/inputs/premDeduct/PremDeduct";
import Program from "components/inputs/program/Program";
import Scenarios from "components/inputs/scenarios/Scenarios";
import SIC from "components/inputs/sic/SIC";
import SideCar from "components/inputs/sideCar/SideCar";
import SurplusLinesTax from "components/inputs/surplusLinesTax/SurplusLinesTax";
import DashboardContent from "components/layout/DashboardContent";
import DashboardHeader from "components/layout/DashboardHeader";
import { connect } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import * as userSelectors from "store/selectors/user/userSelectors";

const Inputs = ({
  tabs,
  isFullWidth,
  hasStickyHeaders,
  navigationState,
  setNavigationState,
}) => {
  const {
    orderSubTabs,
    isSubTabOrderLoading,
  } = navigationSupport.useOrderSubTabs({ tabName: "Inputs" });

  if (isSubTabOrderLoading) {
    return <></>;
  }

  const orderedTabs = orderSubTabs(tabs);

  return (
    <>
      <DashboardHeader
        tabs={orderedTabs}
        parentPath={"inputs"}
        navigationState={navigationState}
        setNavigationState={setNavigationState}
        isFullWidth={isFullWidth}
        sticky={hasStickyHeaders}
      />
      <DashboardContent isFullWidth={isFullWidth}>
        <Routes>
          {orderedTabs.map(({ element, path }) => (
            <Route key={path} path={`${path}/*`} element={element} />
          ))}
          <Route
            path={"*"}
            element={
              <Navigate
                to={
                  navigationState?.inputs != null &&
                  orderedTabs.some((tab) => tab.path === navigationState.inputs)
                    ? navigationState.inputs
                    : orderedTabs[0].path
                }
                replace={true}
              />
            }
          />
        </Routes>
      </DashboardContent>
    </>
  );
};

const TABS = [
  {
    title: "Program",
    path: "program",
    element: <Program />,
    visibilityTag: "input.program",
    defaultVisibility: true,
  },
  {
    title: "Layers",
    path: "layers",
    element: <LayerEditor />,
    visibilityTag: "input.layers",
    defaultVisibility: false,
  },
  {
    title: "Tower",
    path: "brokerTower",
    element: <BrokerTowerTab />,
    visibilityTag: "input.brokerTower",
    defaultVisibility: false,
  },
  {
    title: "Claims",
    path: "claims",
    element: <Claims />,
    visibilityTag: "input.claims",
    defaultVisibility: true,
  },
  {
    title: "SIC",
    path: "sic",
    element: <SIC />,
    visibilityTag: "input.sic",
    defaultVisibility: false,
  },
  {
    title: "Profile",
    path: "prem-deduct",
    element: <PremDeduct />,
    visibilityTag: "input.prem-deduct",
    defaultVisibility: false,
  },
  {
    title: "Loss Development",
    path: "loss-development",
    element: <LossDevelopment />,
    visibilityTag: "input.loss-development",
    defaultVisibility: false,
  },
  {
    title: "Exposure",
    path: "exposure",
    element: <Exposure />,
    visibilityTag: "input.exposure",
    defaultVisibility: true,
  },
  {
    title: "Flags",
    path: "flags",
    element: <Flags />,
    visibilityTag: "input.flags",
    defaultVisibility: true,
  },
  {
    title: "Scenarios",
    path: "scenarios",
    element: <Scenarios />,
    visibilityTag: "input.scenarios",
    defaultVisibility: true,
  },
  {
    title: "Attachments",
    path: "attachments",
    element: <Attachments />,
    visibilityTag: "input.attachments",
    defaultVisibility: true,
  },
  {
    title: "Sidecar",
    path: "sidecar",
    element: <SideCar />,
    visibilityTag: "input.sidecar",
    defaultVisibility: false,
  },
  {
    title: "SOV",
    path: "sov",
    element: <SOV />,
    visibilityTag: "input.sov",
    defaultVisibility: false,
  },
  {
    title: "Property SOV",
    path: "property-sov",
    element: <PropertySov />,
    visibilityTag: "input.property-sov",
    defaultVisibility: false,
  },
  {
    title: "Coverages",
    path: "coverages",
    element: <Coverages />,
    visibilityTag: "input.coverages",
    defaultVisibility: false,
  },
  {
    title: "Cat Exposures",
    path: "cat-exposures",
    element: <CatExposures />,
    visibilityTag: "input.cat_exposures",
    defaultVisibility: false,
  },
  {
    title: "GL Exposures",
    path: "gl-exposures",
    element: <GlExposures />,
    visibilityTag: "input.gl_exposures",
    defaultVisibility: false,
  },
  {
    title: "Auto Exposure Rating",
    path: "auto-exposure-rating",
    element: <AutoExposureRating />,
    visibilityTag: "input.auto_exposure_rating",
    defaultVisibility: false,
  },
  {
    title: "Loss Rating",
    path: "loss-rating",
    element: <LossRatingInput />,
    visibilityTag: "input.loss_rating",
    defaultVisibility: false,
  },
  {
    title: "Pricing Assumptions",
    path: "pricing_assumptions",
    element: <PricingAssumptions />,
    visibilityTag: "input.pricing_assumptions",
    defaultVisibility: false,
  },
  {
    title: "FX Rates",
    path: "fx_rates",
    element: <Currencies />,
    visibilityTag: "input.fx_rates",
    defaultVisibility: false,
  },
  {
    title: "SL Tax",
    path: "surplus-lines-tax",
    element: <SurplusLinesTax />,
    visibilityTag: "input.surplus-lines-tax",
    defaultVisibility: false,
  },
];

export const mapStateToProps = (state) => {
  const userConfig = userSelectors.selectUserConfig(state);
  const stateVisibilitySelectors = userSelectors.getComponentOnStateVisibility(
    state
  );
  const submissionTags = state?.input?.program?.tags ?? [];
  const hasSidecarTag = submissionTags.some((tag) => tag === "SIDECAR");
  return {
    tabs: TABS.filter((tab) => {
      if (tab.path === "sidecar" && !hasSidecarTag) {
        return false;
      }
      const tag = tab.visibilityTag;
      const stateIndependentVisibility =
        userConfig.componentVisibility?.[tag] ?? tab.defaultVisibility;
      const stateVisibilty =
        stateVisibilitySelectors?.[tag] ?? (() => stateIndependentVisibility);
      return stateVisibilty(state) ?? stateIndependentVisibility;
    }),
  };
};

export default connect(mapStateToProps)(Inputs);
